import { z } from 'zod';

/** Suppression lists and the global control group (BB-49). Changes are admin-only (`env.manage`). */
const Name = z.string().trim().min(1).max(200);
const TagIds = z.array(z.uuid()).max(50);

export const CreateSuppressionListBody = z.strictObject({ name: Name, description: z.string().trim().max(1000).nullable().optional(), definition: z.unknown(), exceptionTagIds: TagIds.optional() });
export type CreateSuppressionListBody = z.infer<typeof CreateSuppressionListBody>;
export const UpdateSuppressionListBody = z
  .strictObject({ name: Name.optional(), description: z.string().trim().max(1000).nullable().optional(), definition: z.unknown().optional(), exceptionTagIds: TagIds.optional() })
  .refine((b) => Object.values(b).some((v) => v !== undefined), 'nothing to change');
export type UpdateSuppressionListBody = z.infer<typeof UpdateSuppressionListBody>;

export interface SuppressionListView {
  id: string;
  name: string;
  description: string | null;
  definition: Record<string, unknown>;
  status: 'inactive' | 'active';
  exceptionTagIds: string[];
  activatedAt: string | null;
  createdAt: string;
  updatedAt: string;
  archivedAt: string | null;
}

export const EnableGlobalControlBody = z.strictObject({ percent: z.number().int().min(1).max(15), exemptTagIds: TagIds.optional() });
export type EnableGlobalControlBody = z.infer<typeof EnableGlobalControlBody>;

export interface GlobalControlGroupView {
  id: string;
  percent: number;
  bucketRanges: Array<[number, number]>;
  exemptTagIds: string[];
  enabledAt: string;
  disabledAt: string | null;
  createdBy: { id: string; email: string | null } | null;
}

export interface GlobalControlView {
  active: GlobalControlGroupView | null;
  /** Every group, newest first (a group is never changed: off + a new one). */
  history: GlobalControlGroupView[];
}
